
import { groupBy } from "lodash";
import "vue-collapsible-component/lib/vue-collapsible.css";
import Collapsible from "vue-collapsible-component";
import ChevronUp from "@/assets/svg/heroicons/chevron-up.svg?inline";
import ChevronDown from "@/assets/svg/heroicons/chevron-down.svg?inline";
import PlusIcon from "@/assets/svg/heroicons/plus.svg?inline";
import CloseIcon from "@/assets/svg/heroicons/close.svg?inline";

export default {
  components: {
    Collapsible,
    ChevronUp,
    ChevronDown,
    PlusIcon,
    CloseIcon,
  },
  props: {
    productSlug: {
      type: [Array, Object],
      required: true,
    },
    hasProductIntroduction: {
      type: Boolean,
      required: true,
    },
    productTopFeatures: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.items = groupBy(this.productSlug, "group");
  },
  methods: {
    collapseAll() {
      this.$refs.collapsible.map((element) => (element.open = false)); // eslint-disable-line no-return-assign
    },
    expandAll() {
      this.$refs.collapsible.map((element) => (element.open = true)); // eslint-disable-line no-return-assign
    },
  },
};
